import axios from "axios";
export default {
  namespaced: true,
  state: {
    schedules: null,
    schedule: null,
  },
  getters: {
    schedules(state) {
      return state.schedules;
    },
  },
  mutations: {
    SET_SCHEDULES(state, schedules) {
      state.schedules = schedules;
    },
    ADD_SCHEDULE(state, schedule) {
      if (state.schedules) state.schedules.push(schedule);
      else state.schedules = [schedule];
    },
    EDIT_SCHEDULE(state, schedule) {
      let index = null;
      state.schedules.forEach(function (element, i) {
        if (element.id == schedule.id) index = i;
      });
      state.schedules.splice(index, 1, schedule);
    },
    DELETE_SCHEDULE(state, schedule_id) {
      state.schedules = state.schedules.filter(
        (schedule) => schedule.id != schedule_id
      );
    },
  },
  actions: {
    async get_schedules({ commit }) {
      let response = await axios.get("/schedules");
      commit("SET_SCHEDULES", response.data);
    },
    async add_schedule({ commit, dispatch }, request) {
      let response = await axios.post("/schedule", request);
      commit("ADD_SCHEDULE", response.data);
      // a new default unsets the old one server-side; refresh to reflect it
      if (request.is_default) await dispatch("get_schedules");
    },
    async edit_schedule({ commit, dispatch }, request) {
      let response = await axios.put("/schedule", request);
      commit("EDIT_SCHEDULE", response.data);
      if (request.is_default) await dispatch("get_schedules");
    },
    async delete_schedule({ commit }, schedule_id) {
      await axios.delete("/schedule/" + schedule_id);
      commit("DELETE_SCHEDULE", schedule_id);
    },
  },
};
